module.exports = __webpack_public_path__ + "static/media/sportfitness.f6187ef3.svg";